import React from "react";

const ComingSoon = ({ title = "Module" }) => {
  return (
    <div style={{ padding: "24px" }}>
      <h4 style={{ marginBottom: "8px", fontWeight: 700 }}>{title}</h4>
      <p style={{ color: "#667085", margin: 0 }}>
        This module UI will be prepared in the next phase.
      </p>
    </div>
  );
};

export default ComingSoon;
